import { cn } from "@/utils/cn";
import { memo } from "react";

interface SmileShadowProps {
  className?: string;
}

export const SmileShadow = memo(function SmileShadow({
  className,
}: SmileShadowProps) {
  return (
    <img
      src="/assets/images/smile-shadow.svg"
      alt="Smile shadow"
      className={cn("w-[300x] h-[367px]", className)}
    />
  );
});
